import styled from 'styled-components';

export const CoverContainer = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-rows: 70% 30%;
`;
export const BackCoverContainer = styled.div`
  height: 100%;
`;

export const ImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: 10px;
`;

export const BackImageContent = styled.div`
  height: 100%;
  align-self: center;
  justify-self: center;
  flex-direction: column;
  display: flex;
  row-gap: 15px;
  align-items: center;
  justify-content: center;
`;
export const BackImageContainer = styled.div`
  max-width: 300px;
  max-height: 200px;
  align-self: center;
  justify-self: center;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    max-height: 100%;
    width: auto;
    min-width: 100%;
    object-fit: cover;
    object-position: center;
    transform: scale(1);
    transform-origin: center center;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 25px 0;
`;
export const Typology = styled.div`
  font-family: 'Roboto', sans-serif;
  font-size: clamp(18px, 4vw, 40px);
  font-weight: 400;
  color: ${(props) => props.color};
`;
export const CompanyName = styled.div`
  font-family: 'Roboto', sans-serif;
  text-align: center;
  font-size: 30px;
  font-weight: 500;
  color: #212632;
`;
export const CompanyInfo = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  font-family: 'Roboto', sans-serif;
  font-size: 18px;
  font-weight: 400;
  color: #747d93;
`;
export const Address = styled.div`
  font-family: 'Roboto', sans-serif;
  font-size: clamp(18px, 4vw, 40px);
  font-weight: 500;
  text-align: start;
  color: #212632;
  word-break: break-word;
`;

type ChipProps = {
  $isSale: boolean;
};
export const OperationChip = styled.div<ChipProps>`
  background-color: ${(props) => (props.$isSale ? '#E4FAFF' : '#FFF0E8')};
  border-radius: 20px;
  color: ${(props) => (props.$isSale ? '#0077B6' : '#B56820')};
  padding: 4px 15px;
  font-size: 18px;
  font-weight: 700;
  justify-self: flex-end;
  margin-top: auto;
`;
